/**
 * Auto-generated typed query keys for React Query
 * Generated from GraphQL operations
 * 
 * Usage:
 * - queryClient.resetQueries([queryKeys.brandBookings], { exact: false })
 * - queryClient.invalidateQueries([queryKeys.myBookings], { exact: false })
 */
export const queryKeys = {
  listingMarkers: 'ListingMarkers' as const,
  accounts: 'Accounts' as const,
  billing: 'Billing' as const,
  billingBanner: 'BillingBanner' as const,
  getBookingPost: 'getBookingPost' as const,
  brandBilling: 'BrandBilling' as const,
  brandBookings: 'brandBookings' as const,
  brandBookingNotes: 'brandBookingNotes' as const,
  brandBriefs: 'BrandBriefs' as const,
  brandContentBrief: 'BrandContentBrief' as const,
  brandGroupInvite: 'BrandGroupInvite' as const,
  brandGroupListings: 'BrandGroupListings' as const,
  brandGroupLocations: 'BrandGroupLocations' as const,
  brandInvite: 'BrandInvite' as const,
  brandListing: 'BrandListing' as const,
  brandListings: 'BrandListings' as const,
  brandLocation: 'BrandLocation' as const,
  brandLocations: 'BrandLocations' as const,
  brandNotificationCount: 'BrandNotificationCount' as const,
  brandScheduleSnapshot: 'brandScheduleSnapshot' as const,
  conversationMessages: 'conversationMessages' as const,
  creatorNotes: 'CreatorNotes' as const,
  dietaryPreferences: 'DietaryPreferences' as const,
  dmnBookingTypes: 'DmnBookingTypes' as const,
  emailSubscriptions: 'EmailSubscriptions' as const,
  generateBookingNote: 'GenerateBookingNote' as const,
  getBooking: 'getBooking' as const,
  getBookingPostSubmission: 'GetBookingPostSubmission' as const,
  bookingPostSubmissions: 'BookingPostSubmissions' as const,
  bookingsMetrics: 'BookingsMetrics' as const,
  getBrand: 'GetBrand' as const,
  getBrandApprovalResponseTimes: 'GetBrandApprovalResponseTimes' as const,
  getBrandBillingStatus: 'GetBrandBillingStatus' as const,
  brandContent: 'BrandContent' as const,
  getBrandGroup: 'GetBrandGroup' as const,
  getBrandHandles: 'GetBrandHandles' as const,
  getBrandSocials: 'GetBrandSocials' as const,
  categories: 'Categories' as const,
  getOrCreateConversation: 'GetOrCreateConversation' as const,
  getCreator: 'getCreator' as const,
  getDeclineReasons: 'GetDeclineReasons' as const,
  getListingInvites: 'getListingInvites' as const,
  getLocation: 'GetLocation' as const,
  reportBookingPosts: 'ReportBookingPosts' as const,
  reports: 'Reports' as const,
  instagramBusinessAccounts: 'InstagramBusinessAccounts' as const,
  listingKeyDates: 'listingKeyDates' as const,
  myBookings: 'myBookings' as const,
  place: 'place' as const,
  posts: 'Posts' as const,
  preview: 'Preview' as const,
  reportMetrics: 'ReportMetrics' as const,
  searchPlaces: 'searchPlaces' as const,
  timeSlots: 'TimeSlots' as const,
  toggleProducts: 'ToggleProducts' as const,
} as const;

// Helper type to extract query key from the factory  
export type QueryKey = ReturnType<typeof queryKeys[keyof typeof queryKeys]>;
